import React from "react";
import { useParams } from "react-router-dom";

import PageWrapper from "../../../components/layout/page/PageWrapper";
import PageHeader from "../../../components/layout/page/PageHeader";
import Heading from "../../../components/typography/Heading";
import Text from "../../../components/typography/Text";

import MemberGroupsView from "../members/views/myGroups/MemberGroupsView";
import MemberGroupDashboard from "../members/views/dashboard/MemberGroupDashboard";

export default function GroupsPage({ userId }) {
  const { groupTag } = useParams();

  if (groupTag) {
    return (
      <PageWrapper>
        <MemberGroupDashboard userId={userId} groupTag={groupTag} />
      </PageWrapper>
    );
  }

  return (
    <PageWrapper>
      <PageHeader>
        <Heading>Groups</Heading>
        <Text>Join a group and access the groups you're part of.</Text>
      </PageHeader>

      <MemberGroupsView userId={userId} />
    </PageWrapper>
  );
}
